import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-task-description',
  templateUrl: './task-description.component.html',
  styleUrls: ['./task-description.component.css']
})
export class TaskDescriptionComponent implements OnInit {
  @Input() description=undefined
  descriptionJson=undefined
  parts =undefined
  layouts=undefined
  isLoaded=false
  constructor() { }

  ngOnInit(): void {
    if(this.description){

      this.descriptionJson= JSON.parse(this.description)
      if(this.descriptionJson){
        this.parts =this.descriptionJson['parts']
        this.layouts =this.descriptionJson['layouts']
        this.isLoaded=true
      }

    }

  }

}
